import React from "react";
import btnClasses from "./commons/Button.module.scss";

export const ContactForm = ({ changeData, sendForm, errors, userData }) => {
  return (
    <form method="post" action="" className="form col">
      <label
        className={`field a-field a-field_a1 form__field ${
          errors["your_name"] ? "a-field_error" : ""
        }`}
      >
        <input
          className="field__input a-field__input"
          placeholder="NAME"
          name="your_name"
          onChange={changeData}
          value={userData["your_name"]}
        />
        <span className="a-field__label-wrap">
          <span className="a-field__label">NAME*</span>
        </span>
      </label>
      {errors["your_name"]}
      <label
        className={`field a-field a-field_a1 form__field ${
          errors["your_email"] ? "a-field_error" : ""
        }`}
      >
        <input
          type="email"
          className="field__input a-field__input"
          placeholder="EMAIL"
          name="your_email"
          value={userData["your_email"]}
          onChange={changeData}
        />
        <span className="a-field__label-wrap">
          <span className="a-field__label">EMAIL*</span>
        </span>
      </label>
      {errors["your_email"]}
      <label className="field a-field a-field_a1 form__field">
        <textarea
          className="field__input a-field__input a-field__inputTextarea"
          name="your_message"
          cols="30"
          rows="10"
          placeholder="I was just on your website and..."
          value={userData["your_message"]}
          onChange={changeData}
        />
        <span className="a-field__label-wrap">
          <span className="a-field__label a-field__labelTextarea ">
            I was just on your website and...
          </span>
        </span>
      </label>
      <button
        className={btnClasses.button}
        data-content="Submit"
        onClick={sendForm}
      >
        Submit
      </button>
    </form>
  );
};
